import React, {Component} from "react";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import {EditPermissionName, EditPermissionMemo, EditPermissionDetail} from "../Elements/AscElements/PermissionElements";


export default class PermissionUpdateModal extends Component {

    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}>
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.PermissionInfo}
                        </Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <EditPermissionName
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit = {this.props.onTextChange_Limit}
                            charaLimit = {this.props.charaLimit}>
                        </EditPermissionName>
                        <EditPermissionMemo
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit = {this.props.onTextChange_Limit}
                            charaLimit = {this.props.charaLimit}>
                        </EditPermissionMemo>
                        <EditPermissionDetail
                            state={this.props.state}
                            permission={this.props.permission}
                            langText={this.props.langText}
                            boardWidth={this.props.boardWidth}
                            onNestCheckBoxChange = {this.props.onNestCheckBoxChange}
                            onNestSetState = {this.props.onNestSetState}
                            userInfo={this.props.userInfo}>
                        </EditPermissionDetail>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

PermissionUpdateModal.propTypes = {
    state: PropTypes.object.isRequired,
    langText: PropTypes.object.isRequired,
    charaLimit: PropTypes.object.isRequired,
    permission: PropTypes.object.isRequired,
    boardWidth: PropTypes.object.isRequired,
    userInfo: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    validationHandle: PropTypes.func.isRequired,
    onTextChange_Limit: PropTypes.func.isRequired,
    onNestSetState: PropTypes.func.isRequired,
    onNestCheckBoxChange: PropTypes.func.isRequired,
    propSetState: PropTypes.func,
};
